import { Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import { PAGE_ROUTES } from "./panelRouter";

function PanelUser() {
  return (
    <div dir="rtl" className="panel-user">
      <Routes>
        {/* Sidebar به عنوان Layout: خودش رندر میشه و صفحه‌ی فعال داخل Outlet قرار می‌گیره */}
        <Route element={<Sidebar />}>
          {/* مسیر پیش‌فرض وقتی کاربر وارد /panel میشه */}
          <Route index element={<Navigate to="dashboard" replace />} />

          {PAGE_ROUTES.map(({ id, Component, children }) => (
            <Route key={id} path={id} element={<Component />} />
          ))}

          {/*
            زیرصفحه‌ها به‌صورت مسیر مستقل (نه تودرتو با Outlet) رندر میشن:
            وقتی کاربر مثلاً میره /panel/manage-shops/12/pages، به‌جای
            ManageShops کلاً EditShopPages نمایش داده میشه.
          */}
          {PAGE_ROUTES.flatMap(({ id, children }) =>
            (children || []).map((child) => (
              <Route
                key={`${id}/${child.path}`}
                path={`${id}/${child.path}`}
                element={<child.Component />}
              />
            )),
          )}
        </Route>
      </Routes>
    </div>
  );
}

export default PanelUser;

/*
  نکته: در فایل اصلی اپلیکیشن (مثلاً App.jsx) باید این کامپوننت را
  زیر یک مسیر wildcard قرار دهید تا مسیرهای فرزند هم کار کنند:

  import { BrowserRouter, Routes, Route } from "react-router-dom";
  import PanelUser from "./panelUser";

  <BrowserRouter>
    <Routes>
      <Route path="/panel/*" element={<PanelUser />} />
    </Routes>
  </BrowserRouter>

  ---

  نحوه‌ی اضافه کردن یک زیرصفحه‌ی جدید:
  1) کامپوننتش رو بساز (مثلاً EditShopPages.jsx) و از useParams برای
     گرفتن شناسه (مثلاً shopId) و از useNavigate برای برگشت استفاده کن.
  2) توی panelRouter.js ایمپورتش کن و داخل children همون صفحه‌ی والد اضافه‌ش کن:
       { path: ":shopId/pages", Component: EditShopPages }
  3) توی کامپوننت والد (مثلاً ManageShops.jsx)، به‌جای setState برای
     نمایش زیرصفحه، با navigate به مسیرش برو:
       navigate(`${shop.store_id}/pages`);
     (چون مسیر نسبیه، همون /panel/manage-shops/... ساخته میشه)
*/
